<div class="grammar-renderer-modal">
    <div class="modal-header">
        <h2 mat-dialog-title>{{ title }}</h2>
        <material-button
            class="close-button"
            buttonType="icon"
            [size]="'small'"
            [prefixIcon]="'close'"
            [prefixIconType]="'material'"
            [titleText]="'Close'"
            disableRipple
            (buttonClicked)="onClose()"></material-button>
    </div>

    <div mat-dialog-content class="modal-content px-[24px]">
        <lib-grammar-renderer [grammar]="data.grammar" [flowId]="flowId" [context]="context" #renderer></lib-grammar-renderer>
    </div>

    <div mat-dialog-actions class="modal-actions">
        <material-button
            *ngIf="hasExistingConfiguration"
            class="delete-button"
            [classList]="['!w-auto', '!mr-auto']"
            [text]="'Delete Configuration'"
            [color]="'danger'"
            (buttonClicked)="onDeleteConfiguration()"></material-button>
        <material-button
            class="reset-button"
            [classList]="['!w-auto']"
            [text]="'Reset'"
            [color]="'default'"
            (buttonClicked)="renderer?.resetForm()"></material-button>
        <material-button
            class="cancel-button"
            [classList]="['!w-auto']"
            [text]="'Cancel'"
            [color]="'default'"
            (buttonClicked)="onClose()"></material-button>
        <material-button
            class="apply-button"
            [classList]="['!w-auto']"
            [text]="'Apply'"
            [color]="'primary'"
            [disabled]="!renderer || renderer.form?.invalid"
            (buttonClicked)="onApply(renderer?.getFormData())"></material-button>
    </div>
</div>
